import { applyInlineStyles } from '../utils/dom-style'
import { type EmbedderContext } from './embedder'

/**
 * Embed component interface.
 */
export interface EmbedIFrameComponent {
  rootEl: HTMLElement
  iframeEl: HTMLIFrameElement
}

export class DefaultIFrameEmbedComponent {
  rootEl: HTMLElement
  iframeEl: HTMLIFrameElement
  ctx: EmbedderContext

  constructor (url: string, ctx: EmbedderContext) {
    this.ctx = ctx
    this.rootEl = ctx.createElement('div')
    const rootClasses = [...(this.ctx.settings.classes ?? [])]
    this.rootEl.classList.add(...rootClasses)
    const iframeEl = ctx.createElement('iframe')
    iframeEl.src = url
    this.iframeEl = iframeEl
    const styles = {
      width: '100%',
      height: '100%',
      border: 'none',
      'box-sizing': 'border-box',
      'background-color': 'transparent',
      'overflow-x': 'hidden',
      'color-scheme': 'light',
      ...(ctx.isDebugEnabled() && {
        border: `2px solid ${ctx.settings.debugColor ?? 'red'}`
      })
    }
    applyInlineStyles(styles, iframeEl)
    this.rootEl.appendChild(iframeEl)
  }
}
